import { FaFacebookF } from "react-icons/fa";
import { openShareLink } from "../Helper";
import { useAtom } from "jotai";
import { isSharingAtom, shareTextAtom } from "../pages/Home";
import { FaReddit, FaSnapchat, FaWhatsapp, FaXTwitter } from "react-icons/fa6";
import { PiPinterestLogo, PiSnapchatLogoDuotone } from "react-icons/pi";
import { RiSnapchatFill } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
export const BottomShare = () => {
  const [shareText, setShareText] = useAtom(shareTextAtom);
  const [isSharing, setSharing] = useAtom(isSharingAtom);
  return (
    <>
      <div
        tabIndex={-1}
        className={"bottom-share" + (isSharing ? " open" : "")}
      >
        <p>Share</p>
        <button tabIndex={-1} className="bottom-share__close">
          <IoMdClose
            onClick={() => {
              setSharing(false);
            }}
            size={24}
          />
        </button>
        <div>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "facebook"
              );
            }}
          >
            <FaFacebookF size={24} />
          </button>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "twitter"
              );
            }}
          >
            <FaXTwitter size={24} />
          </button>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "reddit"
              );
            }}
          >
            <FaReddit size={24} />
          </button>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "whatsapp"
              );
            }}
          >
            <FaWhatsapp size={24} />
          </button>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "pinterest"
              );
            }}
          >
            <PiPinterestLogo size={24} />
          </button>
          <button
            tabIndex={-1}
            onClick={() => {
              openShareLink(
                window.location.href,
                "Strands Versus",
                shareText,
                "snapchat"
              );
            }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 256 256"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M240,183.9c-9.25,8.69-31.45,4.61-42.66,10.78-11,6.07-17.07,25.56-29.57,28.76-12.08,3.09-26.72-7.56-39.77-7.56s-27.69,10.65-39.77,7.56c-12.5-3.2-18.53-22.69-29.57-28.76C47.45,188.51,25.25,192.59,16,183.9c0,0,56-20,56-103.93a56,56,0,0,1,112,0C184,163.86,240,183.9,240,183.9Z"
                opacity="1"
              ></path>
              <path
                fill="black"
                d="M247.83,182.28a8,8,0,0,0-5.13-5.9c-.39-.14-28.95-10.88-43-49.23l19.3-7.72A8,8,0,1,0,213,104.57l-17.82,7.13A149,149,0,0,1,192,80,64,64,0,0,0,64,80a151.24,151.24,0,0,1-3.18,31.75L43,104.57A8,8,0,1,0,37,119.43l19.37,7.75a94,94,0,0,1-17.74,30.2c-12.52,14.14-25.27,19-25.36,19a8,8,0,0,0-2.77,13.36c7.1,6.67,17.67,7.71,27.89,8.72,6.3.62,12.82,1.27,16.38,3.23,3.37,1.86,6.85,6.62,10.21,11.22,5.4,7.41,11.53,15.8,21.24,18.28,9.07,2.33,18.35-.83,26.54-3.62,5.55-1.89,10.8-3.68,15.21-3.68s9.66,1.79,15.21,3.68c6.2,2.11,13,4.43,19.9,4.43a26.35,26.35,0,0,0,6.64-.81h0c9.7-2.48,15.83-10.87,21.23-18.28,3.36-4.6,6.84-9.36,10.21-11.22,3.56-2,10.08-2.61,16.39-3.23,10.21-1,20.78-2.05,27.88-8.72A8,8,0,0,0,247.83,182.28Zm-31.82.26c-7.91.78-16.08,1.59-22.53,5.13s-11,9.79-15.41,15.81c-4,5.48-8.15,11.16-12.28,12.21-4.46,1.15-10.76-1-17.42-3.27s-13.31-4.53-20.37-4.53-13.83,2.3-20.37,4.53-13,4.42-17.42,3.27c-4.13-1.05-8.27-6.73-12.28-12.21-4.39-6-8.93-12.24-15.41-15.81S47.9,183.32,40,182.54c-1.56-.15-3.15-.31-4.74-.49a97.34,97.34,0,0,0,14.69-13.29c8.37-9.27,17.72-23.23,23.74-43.13l.06-.13a8.63,8.63,0,0,0,.46-1.61A158.47,158.47,0,0,0,80,80a48,48,0,0,1,96,0,158.42,158.42,0,0,0,5.8,43.92,8.63,8.63,0,0,0,.46,1.61l.06.13c6,19.9,15.37,33.86,23.74,43.13a97.34,97.34,0,0,0,14.69,13.29C219.16,182.23,217.57,182.39,216,182.54Z"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};
